<template>
  <section id="contactForm" class="uk-container-expand">
    <section id="contactFormTwo"></section>
    <section id="contactFormFour"></section>
    <section id="contactFormThree"></section>
    <div class="uk-container contact-form-padding contact-form" ref="container">
      <div class="margin-top-bottom-50">
        <h2 class="no-border contact-form-title-text">
          Heb je een vraag?
        </h2>
        <div class="width-80-percent uk-margin-auto uk-margin-remove-top uk-text-center
        contact-form-subtitle-text">
          <p>
            Neem gerust contact met mij op of vraag vrijblijvend een offerte aan.
            Bellen kan ook altijd, dat vind ik alleen maar leuk.
          </p>
          <p class="uk-animation-shake uk-text-danger uk-text-bold" v-if="error"
             id="contactFormError">
            Helaas ging er iets fout met het verzenden. Probeer het nogmaals of stuur mij een
            e-mail via: <a href="mailto:info@roosnetjes.nl">info@roosnetjes.nl</a>
          </p>
          <form class="uk-text-left uk-margin-small" action="" ref="form"
                method="POST" @submit="prevent">
            <div class="contact-margin-fix" uk-grid>
              <div class="uk-flex width-100-percent contact-flex">
                <div class="uk-width-1-1@m">
                  <label class="uk-form-label form-input-title" for="contactform[name]">
                    Je naam
                  </label>
                  <div class="uk-form-controls padding-right-5 padding-bottom-5">
                    <input type="text"
                           id="contactform[name]"
                           name="contactform[name]"
                           ref="contactForm__name"
                           v-model.trim="contactForm.name"
                           class="uk-input form-input-data" placeholder="Je naam" required>
                  </div>
                </div>

                <div class="uk-width-1-1@m">
                  <label class="uk-form-label form-input-title padding-left-5"
                         for="contactform[email]">
                    E-mailadres
                  </label>
                  <div class="uk-form-controls padding-left-5">
                    <input type="email" class="uk-input form-input-data"
                           id="contactform[email]"
                           name="contactform[email]"
                           ref="contactForm__email"
                           v-model.trim="contactForm.email"
                           placeholder="Je e-mailadres"
                           required
                    >
                  </div>
                </div>
              </div>

              <div class="uk-width-1-1">
                <label
                  class="uk-form-label form-input-title"
                  for="contactform[question]">Wat wil je vragen?</label>
                <div class="uk-form-controls">
                    <textarea id="contactform[question]"
                              name="contactform[question]"
                              v-model.trim="contactForm.question"
                              ref="contactForm__question"
                              class="uk-textarea form-input-data"
                              rows="3"
                              required
                              placeholder="Stel je vraag..."
                    />
                </div>
              </div>
              <div class="uk-display-block contact-form-button">
                <button type="submit"
                        class="
                            g-recaptcha
                            uk-button
                            uk-button-default
                            contact-form-button-color
                            voice-over-button-clickable-section
                            uk-display-block small-button-orange"
                >
                  <a class="contact-form-button-orange-text text-transform-none">
                    Verstuur bericht
                  </a>
                </button>
                <br>
                <recaptcha ref="recaptcha"
                           class="uk-hidden"
                           @verify="sendForm"/>
              </div>
            </div>
          </form>
          <div class="contact-form-footer uk-margin-medium-top">
            <div class="uk-flex contact-form-footer-flex">
              <p class="contact-form-footer-text">
                Of neem direct <br> contact op met mij
              </p>
              <div class="contact-form-footer-roos">
                <div class="contact-form-footer-flex-left">
                  <img
                    :src="require('@/assets/images/rvdsb-1@small.png')"
                    class="contact-form-footer-roos-image"
                  />
                </div>
                <div class="contact-form-footer-flex-right">
                  <label class="contact-form-footer-roos-label">Roos Netjes</label>
                  <a href="tel:31641744233">+31 6 417 44 2 33</a>
                  <a href="mailto:info@roosnetjes.nl">info@roosnetjes.nl</a>
                </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import fetch from 'node-fetch';
import UIkit from 'uikit';
import Recaptcha from './Recaptcha.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const config = require('@/../config');

export default Vue.extend({
  name: 'ContactForm.vue',
  components: { Recaptcha },
  data() {
    return {
      error: false,
      contactForm: {
        name: '',
        email: '',
        question: '',
      },
    };
  },
  watch: {
    error(value) {
      if (value === true) {
        setTimeout(() => {
          UIkit.scroll(null, { offset: 100 }).scrollTo('#contactFormError');
        }, 500);
      }
    },
  },
  methods: {
    prevent(event) {
      event.preventDefault();
      if (!window.webpackHotUpdate) {
        this.$refs.recaptcha.execute();
      } else {
        this.sendForm();
      }
    },
    disableFormFields() {
      const contactFormKeys = Object.keys(this.contactForm);
      contactFormKeys.forEach((field) => {
        if (this.$refs[`contactForm__${field}`]) {
          this.$refs[`contactForm__${field}`].setAttribute('disabled', 'disabled');
        }
      });
    },
    enableFormFields() {
      const contactFormKeys = Object.keys(this.contactForm);
      contactFormKeys.forEach((field) => {
        if (this.$refs[`contactForm__${field}`]) {
          this.$refs[`contactForm__${field}`].removeAttribute('disabled');
        }
      });
    },
    sendForm() {
      this.disableFormFields();
      this.error = false;

      const contactFormKeys = Object.keys(this.contactForm);
      const formData = {};
      contactFormKeys.forEach((field) => {
        formData[field] = this.contactForm[field];
      });

      fetch(config.contactURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.contactForm),
      }).then((response) => {
        if (response.status < 200 || response.status >= 300) {
          this.error = true;
          return;
        }
        this.$refs.form.innerHTML = ''
          + '<h2 class="no-border">Bedankt voor je bericht! <br>Ik reageer zo snel mogelijk.</h2>';
      }).catch((error) => {
        console.error(error);
        this.error = true;
      }).finally(() => {
        this.enableFormFields();
      });
    },
  },
});
</script>

<style scoped>

</style>
